import React from 'react';
import { GridItem } from '../GridItem';
import { CasinoThumbnail } from '../../GameThumbnails/Casino/CasinoThumbnail';
import { useSelector } from 'react-redux';
import { WinnersLoadingInGrid } from '../WinnersLoadingInGrid';
import { CasinoGamesGridContainer } from '../CasinoGamesGridContainer';

/**
 * Component for showing preload games grid until platform games will be ready
 */
export const PreloadGamesGrid = ({
    preloadedGames = []
}) => {
    const { isMobile } = useSelector((state) => state.app);

    if (!Array.isArray(preloadedGames) || !preloadedGames.length) {
        return null;
    }

    return (
        <CasinoGamesGridContainer>
            {!isMobile && <WinnersLoadingInGrid />}

            {preloadedGames.map((preloadGame) => {
                return (
                    <GridItem key={preloadGame.id}>
                        <CasinoThumbnail
                            id={preloadGame.id}
                            name={preloadGame.name}
                            images={preloadGame.images}
                            badges={[]}
                            overlayBadges={[]}
                            openGameHandler={() => { return null; }}
                            isMobile={isMobile}
                        />
                    </GridItem>
                );
            })}
        </CasinoGamesGridContainer>
    );
};
